export { default } from './update-banner';
